import React from 'react';
import { Grid, IconButton, useMediaQuery } from '@mui/material';

import Icon from '../../../Icon';

export interface DetailsPageRightSidebarProps {
	model: any;
	isEdit: boolean;
	isAdd: boolean;
	updateRefresh: VoidFunction;
}

export interface DetailsPageRightSidebarWrapperProps {
	rightSidebarSections?: React.ReactNode[];
	toggleRightSidebar: VoidFunction;
}

export default function DetailsPageRightSidebarWrapper(props: DetailsPageRightSidebarWrapperProps) {
	const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'));

	return (
		<div className="p-16">
			<Grid container spacing={2}>
				{!isDesktop && (
					<Grid>
						<IconButton onClick={props.toggleRightSidebar}>
							<Icon icon="close" />
						</IconButton>
					</Grid>
				)}
				{props.rightSidebarSections?.map((section, index) => (
					<Grid key={index} size={12}>
						{section}
					</Grid>
				))}
			</Grid>
		</div>
	);
}
